<!--
 * @Author: your name
 * @Date: 2020-10-20 11:35:44
 * @LastEditTime: 2020-11-08 11:02:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/addcertification/components/TitleMes/index.vue
-->
<template>
  <div>
    <div class="add_title colo0 font_weight500 font14 text_left">
      <span>{{ title }}</span>
      <span class="title_det"> {{ titleDet }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "身份信息"
    },
    titleDet: {
      type: String,
      default: "（必填）"
    }
  }
};
</script>
<style lang="less" scoped>
.add_title {
  padding: 9px 12px;
  .title_det {
    color: rgba(0, 0, 0, 0.38);
  }
}
</style>
